export { default as CategoryPage } from "./View";
export { default as PageCategory } from "./Page";